import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class HomeService {
  listProduct:[];
  listFournisseur:[];
  constructor(private http: HttpClient) { 
    
  }

  getProduct()
  {
    return this.http.get('https://reqres.in/api/products');
  }

  getProductById(id)
  {
    return this.http.get('https://reqres.in/api/products/'+id);
  }
  
  
}
